import * as React from 'react';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function LinearProgressWithLabel(props: LinearProgressProps & { value: number; total: number }) {
  const percentage = (props.value / props.total) * 100;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center',gap:"10px" }}>
      
      <Box sx={{ flex:8  }}>
        <LinearProgress variant="determinate" value={percentage} sx={{
          bgcolor:"#e5e7eb",
          color:  "#f97316",
              borderRadius: "8px",
        
        }}/>
      </Box>
       <Typography variant="body2" sx={{ color: '#6b7280',fontSize:"14px" }}>
          {`${props.value}/${props.total}`}
        </Typography>
    </Box>
  );
}

export default function LinearWithValueLabel({
  value,
  total,
}: {
  value: number;
  total: number;
}) {
  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgressWithLabel value={value} total={total} />
    </Box>
  );
}
